/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const XlsExport = {

	postExportAgencyProjectTables (context, agencyTablesExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/xls-export/export-agency-project-tables"
			, agencyTablesExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportOfferTables (context, tablesExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/xls-export/export-offer-tables"
			, tablesExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportProjectTables (context, tablesExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/xls-export/export-project-tables"
			, tablesExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
